// The file control. The native input cannot be styled, so it sits off
// screen and a real button forwards to it: same input, same change event,
// same form data. onChange receives the File or null. Optional label, help,
// and error render the same shell as Input.

import { useRef } from 'react'
import { FieldShell } from '../FieldShell/index.jsx'
import { formatBytes } from '../formatBytes.js'
import './filepicker.css'

export function FilePicker({
  id,
  file,
  accept,
  onChange,
  label,
  help,
  error,
  chooseLabel = 'Choose file',
}) {
  const inputRef = useRef(null)

  const control = (
    <div className="ui-filepicker">
      <input
        ref={inputRef}
        id={id}
        type="file"
        className="visually-hidden"
        accept={accept}
        tabIndex={-1}
        onChange={(event) => onChange(event.target.files?.[0] ?? null)}
      />
      <button
        type="button"
        className="ui-btn ui-btn-secondary"
        aria-invalid={error ? true : undefined}
        aria-describedby={`${id}-name`}
        onClick={() => inputRef.current?.click()}
      >
        {file ? 'Change file' : chooseLabel}
      </button>
      <span id={`${id}-name`} className={`ui-filepicker-name${file ? '' : ' is-empty'}`}>
        {file ? `${file.name} · ${formatBytes(file.size)}` : 'No file chosen'}
      </span>
      {file ? (
        <button
          type="button"
          className="ui-btn ui-btn-ghost"
          onClick={() => {
            if (inputRef.current) inputRef.current.value = ''
            onChange(null)
          }}
        >
          Clear
        </button>
      ) : null}
    </div>
  )

  return (
    <FieldShell id={id} label={label} help={help} error={error}>
      {control}
    </FieldShell>
  )
}
